import React from 'react';

export default class Languages extends React.Component {

  render () {
    let {languages, selected} = this.props;

    let items = languages.map(({code, name}) => {
      let cls = code === selected ? 'selected' : '';

      return (
        <li key={code} className={`${code} ${cls}`}
            onClick={() => this.onChange(code)}>
          { name }
        </li>
      );
    });

    return (
      <ul className="Languages">
        { items }
      </ul>
    );
  }

  onChange (code) {
    this.props.onChange(code);
    window.TRACKING_EVENT.event = 'language';
    window.TRACKING_EVENT.language = code;
    window.TRACKING_EVENT.source = 'menu';
  }
}

